import React from 'react';
import { cn } from '@heroui/react';

interface StatCardProps {
  label: React.ReactNode;
  value: string | number;
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, className }) => {
  return (
    <div className={cn(
      'bg-white border border-neutral-200 rounded-[14px] px-[16px] py-[16px] pb-[20px]',
      className
    )}>
      <div className="flex flex-col gap-[16px]">
        <div className="text-[14px] font-medium text-[#71717A] leading-[18px]">
          {label}
        </div>
        <p className="text-[24px] font-semibold text-[#3F3F46] leading-normal">
          {value}
        </p>
      </div>
    </div>
  );
};

export default React.memo(StatCard);
